<template>
    <div class="container mt-3">
        <div class="col-12">
            <b-card no-body>
                <b-tabs v-model="tabIndex" pills card>
                    <b-tab class="mr-2" :title="$t('Cadastro')" active id="tabCadastro">
                        <cadastro-segmento :editMode="editMode" :findSegmento="findSegmento"></cadastro-segmento>
                    </b-tab>
                    <b-tab :title="$t('Lista')">
                        <lista-segmento @setSegmento="setSegmento"></lista-segmento>
                    </b-tab>
                </b-tabs>
            </b-card>
        </div>
    </div>
</template>
  
<script>
import CadastroSegmento from '@/components/ginfo/CadastroSegmento.vue'
import ListaSegmento from '@/components/ginfo/ListaSegmento.vue'

export default {
    data() {
        return {
            editMode: false,
            findSegmento: {},
            tabIndex: 1
        }
    },

    components: {
        CadastroSegmento,
        ListaSegmento
    },

    methods: {
        setSegmento(segmento) {
            // console.log(segmento)
            this.editMode = true
            this.findSegmento = segmento
            this.tabIndex--
        }
    }

}
</script>

<style >
.nav-item {
    margin-right: 9px !important;
}

/* * {
    font-family: poppins;
    font-weight: 300;
} */

.tab-content {
    background: #f7f7f7;
    box-shadow: -3px 4px 11px -7px #000 !important;
    border-radius: 20px;
}
</style>